/**
 * Tab Keyboard Shortcuts Hook
 * Handles global keyboard shortcuts for tab management
 */

import { useEffect } from 'react';
import { useMainContentTabs } from '../store/layoutStore';

/**
 * Hook to enable tab management keyboard shortcuts
 * Cmd+W (Mac) or Ctrl+W (Windows/Linux) - Close active tab
 */
export function useTabKeyboard() {
  const { activeTabId, tabs, closeTab } = useMainContentTabs();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Skip if event was already handled by another handler
      if (event.defaultPrevented) return;

      const isModKey = event.metaKey || event.ctrlKey;

      // Cmd+W (Mac) or Ctrl+W (Windows/Linux) - Close Active Tab
      if (isModKey && event.key === 'w') {
        // Check if there's an active tab and there's more than one tab
        if (activeTabId && tabs && tabs.length > 1) {
          // Prevent default browser close window behavior
          event.preventDefault();

          // Close the active tab
          closeTab(activeTabId);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeTabId, tabs, closeTab]);
}
